<div class="content-card">
    <div class="mat-card mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <div class="">
            <div class="" style="line-height: 20px; padding: 10px;">
                <a class="nav-link" *appIsGranted="['Products', 'ANY']" matRipple [routerLink]="'/products'" [routerLinkActive]="[]">
                    <mat-icon class="nav-link-icon">local_offer</mat-icon>
                    <span>{{'Products'|translate}}</span>
                </a>
                &nbsp;&nbsp;
                <a class="nav-link" *appIsGranted="['Orders', 'ANY']" matRipple [routerLink]="'/orders/new'" [routerLinkActive]="[]">
                    <mat-icon class="nav-link-icon">local_grocery_store</mat-icon>
                    <span>{{'Sale'|translate}}</span>
                </a>

                <a class="nav-link" *appIsGranted="['Orders', 'ANY']" matRipple [routerLink]="'/pos'" [routerLinkActive]="[]">
                    <mat-icon class="nav-link-icon">local_grocery_store</mat-icon>
                    <span>{{'POS'|translate}}</span>
                </a>
                &nbsp;&nbsp;
                <a class="nav-link" *appIsGranted="['Used products', 'ANY']" matRipple [routerLink]="'/uses/new'" [routerLinkActive]="[]">
                    <mat-icon class="nav-link-icon">arrow_downward</mat-icon>
                    <span>{{'Use'|translate}}</span>
                </a>
                &nbsp;&nbsp;
                <a class="nav-link" *appIsGranted="['ASN', 'ANY']" matRipple [routerLink]="'/supplier-orders/new'" [routerLinkActive]="[]">
                    <mat-icon class="nav-link-icon">local_shipping</mat-icon>
                    <span>{{'Deliveries'|translate}}</span>
                </a>
            </div>
        </div>
    </div>
</div>